




























import { Component, Vue } from 'vue-property-decorator';
import { RouterOptions, RouteConfig } from 'vue-router';
import Routes from '@/Routes';
import User from '@/models/User';
import UsersPage from '@/components/Organization/UsersPage.vue';
import DestinationsPage from '@/components/Organization/DestinationsPage.vue';
// import InvoiceTab from '@/components/Organization/InvoiceTab.vue';
import PassengerGroupsPage from '@/components/Organization/PassengerGroupsPage.vue'

@Component({
  components: {
    UsersPage,
    PassengerGroupsPage
  },
})
export default class OrganizationDetails extends Vue {
  organizationId!: any;
  showDestinationsTab: boolean = false;
  tab: number = 0;

  get showEditor() {
    const isEditingUser = this.$route.name === Routes.organizationEditUserRoute.name;
    const isCreatingUser = this.$route.name === Routes.organizationNewUserRoute.name;
    return isEditingUser || isCreatingUser;
  }

  get tabs() {
    return [
      { 
        name: this.$i18n.translate('generic.user.plural', 'Users'),
        component: UsersPage,
        props: { users: this.users, organizationId: this.organizationId },
      },
      { 
        name: this.$i18n.translate('organization.destinations', 'Destinations'), 
        component: DestinationsPage, 
        props: { organizationId: this.organizationId },
      },
      { 
        name: this.$i18n.translate('organization.passengerGroup.plural', 'Passenger groups'), 
        component: PassengerGroupsPage, 
        props: { organizationId: this.organizationId },
      },
    ]
  }

  get users(): User[] {
    return this.$store.state.organization.users;
  }

  get organization() {
    return this.$store.state.organization.organizations.find(o => o.id === this.organizationId);
  }

  set organization(val: any) {
    this.organizationId = val;
  }

  async created() {
    const organizationId = this.$route.params.organizationId;
    this.organization = organizationId;
    return await this.$store
      .dispatch('organization/getUsers', { params: { id: organizationId } });
  }
}
